export default __webpack_public_path__ + "static/media/login.f2b2342a.png";